import React from "react";
import "./commission.scss";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../../store/index.ts";
import ShowContainer from "../../../../mui/ShowContainer.jsx";

export default function Commission({ taxPercent, min = "" }) {
  const { t } = useTranslation();
  const currency = useAppSelector((state) => state.user.currency);

  const percents = Object.keys(taxPercent);
  percents.sort((a, b) => b - a);

  return (
    <ShowContainer condition={percents.length}>
      <section className="commission">
        <h4>{t("Deposit fee:")}</h4>
        {percents.map((percent) => {
          const percentBody = taxPercent[percent];
          const to = percentBody.to || "";
          const from = percentBody.from || "";
          const diapason = from ? `${from} - ${to}` : `${min} - ${to}`;

          if (min > to) {
            return <></>;
          }

          if (+percent) {
            return <p key={percent}>{t("% for payments", { percent, currency, diapason })} </p>;
          }
        })}
        <ShowContainer condition={taxPercent?.[0]?.from}>
          <p>{t("% for payments from", { percent: 0, currency, from: taxPercent[0]?.from })} </p>
        </ShowContainer>
      </section>
    </ShowContainer>
  );
}
